import React from 'react'
import './Layout.css'
import Header from '../Header/Header'

const Layout = ({children}) => {
  return (
    < >
    <Header />
    <div className="layout">{children}</div>          
    </ >
  )
}

export default Layout
